import styles from "./styles.module.scss";

export default NullQuestionBox;

type NullQuestionBoxProps = {
  className: string;
};

function NullQuestionBox({ className }: NullQuestionBoxProps) {
  const { containerBox } = styles;

  const enhancedContainer = (() => {
    const containerClasses = [containerBox];

    if (className) containerClasses.push(className);

    return containerClasses.join(" ");
  })();

  return (
    <div className={enhancedContainer}>
      <Svg />
      <h3>No Suggestions Yet</h3>
      <p>
      Send this room code to your friends and start getting ideas for wonderful gifts!
      </p>
    </div>
  );
}

function Svg() {
  const { primary, secondary, third } = styles;

  return (
    <svg
      width="154"
      height="150"
      viewBox="0 0 154 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.1"
        cx="75"
        cy="75.0001"
        r="75"
        fill="currentColor"
        className={primary}
      />
      <path
        d="M9 29.7231V62.7837V65.1452C9 67.7536 11.1145 69.8681 13.7229 69.8681H44.4221L57.0363 81.512C57.883 82.2935 59.2331 81.5236 58.9917 80.397L56.2295 67.5066H64.4946C67.103 67.5066 69.2175 65.3921 69.2175 62.7837V29.7231C69.2175 27.1147 67.103 25.0001 64.4946 25.0001H13.7229C11.1145 25.0001 9 27.1147 9 29.7231Z"
        fill="currentColor"
        className={primary}
      />
      <path
        d="M153.218 54.7231V87.7837V90.1452C153.218 92.7536 151.103 94.8681 148.495 94.8681H117.795L105.181 106.512C104.335 107.294 102.984 106.524 103.226 105.397L105.988 92.5066H97.7229C95.1145 92.5066 93 90.3921 93 87.7837V54.7231C93 52.1147 95.1145 50.0001 97.7229 50.0001H148.495C151.103 50.0001 153.218 52.1147 153.218 54.7231Z"
        fill="currentColor"
        className={secondary}
      />
      <path
        d="M45 100.41V117.281V118.486C45 119.817 46.0886 120.896 47.4314 120.896H63.2353L69.7291 126.838C70.1649 127.237 70.86 126.844 70.7357 126.269L69.3137 119.691H73.5686C74.9114 119.691 76 118.612 76 117.281V100.41C76 99.0792 74.9114 98.0001 73.5686 98.0001H47.4314C46.0886 98.0001 45 99.0792 45 100.41Z"
        fill="currentColor"
        className={third}
      />
      <circle cx="109.5" cy="71.5001" r="3.5" fill="#F8F8F8" />
      <circle cx="122.5" cy="71.5001" r="3.5" fill="#F8F8F8" />
      <circle cx="135.5" cy="71.5001" r="3.5" fill="#F8F8F8" />
      <circle cx="25.5" cy="46.5001" r="3.5" fill="#F8F8F8" />
      <circle cx="38.5" cy="46.5001" r="3.5" fill="#F8F8F8" />
      <circle cx="51.5" cy="46.5001" r="3.5" fill="#F8F8F8" />
      <circle
        opacity="0.7"
        cx="53.0151"
        cy="109.334"
        r="2.01515"
        fill="#F8F8F8"
      />
      <circle
        opacity="0.7"
        cx="60.4999"
        cy="109.334"
        r="2.01515"
        fill="#F8F8F8"
      />
      <circle
        opacity="0.7"
        cx="67.9849"
        cy="109.334"
        r="2.01515"
        fill="#F8F8F8"
      />
    </svg>
  );
}
